module.exports = __webpack_public_path__ + "img/_ukraine.3b83bfd4.png";